import React from 'react'
import logo from '../images/kvh-logo.png'
import { Button, Col, Container, Nav, NavDropdown, Navbar, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { FaWhatsapp } from 'react-icons/fa'

export default function Header() {
    return (
        <>
            <div className='primary-bg'>
                <Container >
                    <Row className='p-2'>
                        <Col md={6}>
                            <a className='text-decoration-none text-light' href='tel:9825255373'><FaWhatsapp /> +91 98252 55373</a> | <a className='text-decoration-none text-light' href='tel:8347763858'><FaWhatsapp /> +91 83477 63858</a>
                        </Col>
                        <Col md={6} className='text-end d-none d-md-block'>
                            <a href='https://wa.me/+918347763858?text=Hello KVH FURNISHING,  %0a %0a Can I get some more information about curtain fabrics.' target='_blank'>
                                <Button variant='light'>
                                    <FaWhatsapp /> Send Inquiry
                                </Button>
                            </a>
                        </Col>
                    </Row>
                </Container>
            </div>
            <Navbar expand="lg" className="bg-body-tertiary sticky-top navbar-inverse">
                <Container>
                    <Navbar.Brand href="#home">
                        <img src={logo} alt='KVH' className='nav-logo' />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ms-auto">
                            <a className='mx-2 text-dark text-decoration-none' href='#' >Home</a>

                            <a className='mx-2 text-dark text-decoration-none' href='#about' >About Us</a>
                            <a className='mx-2 text-dark text-decoration-none' href='#products' >Our Products</a>
                            <a className='mx-2 text-dark text-decoration-none' href='#contact' >Contact Us</a>

                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    )
}
